import { TextFit } from './text-fit';

export { TextFit };
